<section class="gallery-layout gallery-layout-15">
  <div class="container">
    <div class="row">
      @if (data().items[0]; as item) {
        <div class="col-lg-6 col-xs-12">
          <figure class="figure figure-0">
            @if (item.image; as image) {
              <app-image [image]="image" [size]="{ dh: 441, mh: 245 }" class="img" />
            }
            @if (item.legend; as legend) {
              <figcaption>
                <hr class="separator" />
                <div [innerHTML]="legend" class="legend"></div>
              </figcaption>
            }
          </figure>
        </div>
      }
      @if (data().items[1]; as item) {
        <div class="col-lg-5 col-lg-offset-1 col-xs-12">
          <figure class="figure figure-1">
            @if (item.image; as image) {
              <app-image [image]="image" [size]="{ dh: 729, mh: 421 }" class="img" />
            }
            @if (item.legend; as legend) {
              <figcaption>
                <hr class="separator" />
                <div [innerHTML]="legend" class="legend"></div>
              </figcaption>
            }
          </figure>
        </div>
      }
    </div>
    <div class="row">
      @if (data().items[2]; as item) {
        <div class="col-lg-5 col-xs-12">
          <figure class="figure figure-2">
            @if (item.image; as image) {
              <app-image [image]="image" [size]="{ dh: 324, mh: 421 }" class="img img-3" />
            }
            @if (item.legend; as legend) {
              <figcaption>
                <hr class="separator" />
                <div [innerHTML]="legend" class="legend"></div>
              </figcaption>
            }
          </figure>
        </div>
      }
      <div class="quote quote-0 col-lg-6 col-lg-offset-1 col-xs-12">
        @if (data().quotes && data().quotes![0]; as quote) {
          <app-quote [quote]="{ text: quote }" theme="BROWN" />
        }
      </div>
    </div>
    <div class="row">
      @if (data().items[3]; as item) {
        <div class="col-lg-5 col-xs-12">
          <figure class="figure figure-3">
            @if (item.image; as image) {
              <app-image [image]="image" [size]="{ dh: 729, mh: 421 }" class="img" />
            }
            @if (item.legend; as legend) {
              <figcaption>
                <hr class="separator" />
                <div [innerHTML]="legend" class="legend"></div>
              </figcaption>
            }
          </figure>
        </div>
      }
      @if (data().items[4]; as item) {
        <div class="col-lg-6 col-lg-offset-1 col-xs-12">
          <figure class="figure figure-4">
            @if (item.image; as image) {
              <app-image [image]="image" [size]="{ dh: 441, mh: 245 }" class="img" />
            }
            @if (item.legend; as legend) {
              <figcaption>
                <hr class="separator" />
                <div [innerHTML]="legend" class="legend"></div>
              </figcaption>
            }
          </figure>
          @if (data().items[5]; as item) {
            <div class="row">
              <div class="col-lg-10 col-lg-offset-2 col-xs-12">
                <figure class="figure figure-5">
                  @if (item.image; as image) {
                    <app-image [image]="image" [size]="{ dh: 324, mh: 421 }" class="img" />
                  }
                  @if (item.legend; as legend) {
                    <figcaption>
                      <hr class="separator" />
                      <div [innerHTML]="legend" class="legend"></div>
                    </figcaption>
                  }
                </figure>
              </div>
            </div>
          }
        </div>
      }
    </div>
    <div class="row">
      <div class="quote quote-1 col-lg-6 col-xs-12">
        @if (data().quotes && data().quotes![1]; as quote) {
          <app-quote [quote]="{ text: quote }" theme="BROWN" />
        }
      </div>
    </div>
    <div class="row">
      @if (data().items[6]; as item) {
        <div class="col-lg-6 col-xs-12">
          <figure class="figure figure-6">
            @if (item.image; as image) {
              <app-image [image]="image" [size]="{ dh: 441, mh: 245 }" class="img" />
            }
            @if (item.legend; as legend) {
              <figcaption>
                <hr class="separator" />
                <div [innerHTML]="legend" class="legend"></div>
              </figcaption>
            }
          </figure>
        </div>
      }
      @if (data().items[7]; as item) {
        <div class="col-lg-5 col-lg-offset-1 col-xs-12">
          <figure class="figure figure-7">
            @if (item.image; as image) {
              <app-image [image]="image" [size]="{ dh: 364, mh: 400 }" class="img" />
            }
            @if (item.legend; as legend) {
              <figcaption>
                <hr class="separator" />
                <div [innerHTML]="legend" class="legend"></div>
              </figcaption>
            }
          </figure>
        </div>
      }
    </div>
  </div>
</section>
